import { render, staticRenderFns } from "./ConsultantNotificationSettings.vue?vue&type=template&id=14898aaa"
import script from "./ConsultantNotificationSettings.vue?vue&type=script&lang=js"
export * from "./ConsultantNotificationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports